import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class PaisesService extends ApiService {
  entityType = EntityType.PAIS;
  url = 'api/paises/';
}
